import tabs from "./ru/tabs";
import pages from "./ru/pages";
import appLauncher from "./ru/appLauncher";
import apps from "./ru/apps";
import auditLog from "./ru/auditLog";
import roadmapPage from "./ru/roadmapPage";
import ceoQueue from "./ru/ceoQueue";
import common from "./ru/common";
import speedDial from "./ru/speedDial";
import smartBar from "./ru/smartBar";
import auth from "./ru/auth";
import settings from "./ru/settings";
import sidebar from "./ru/sidebar";
import tray from "./ru/tray";
import shellPrefs from "./ru/shellPrefs";
import userMenu from "./ru/userMenu";
import downloads from "./ru/downloads";
import brand from "./ru/brand";
import contextMenu from "./ru/contextMenu";
import elementLabels from "./ru/elementLabels";
import elementDescriptions from "./ru/elementDescriptions";
import guide from "./ru/guide";
import folders from "./ru/folders";
import fieldLibrary from "./ru/fieldLibrary";
import canvas from "./ru/canvas";
import storyMap from "./ru/storyMap";
import health from "./ru/health";
import dashboardHome from "./ru/dashboardHome";
import hub from "./ru/hub";
import boardroom from "./ru/boardroom";
import documentsPage from "./ru/documentsPage";
import exportNs from "./ru/export";
import docControl from "./ru/docControl";
import docTemplates from "./ru/docTemplates";
import docFields from "./ru/docFields";
import fieldConfig from "./ru/fieldConfig";
import emailTemplates from "./ru/emailTemplates";
import emailDesigner from "./ru/emailDesigner";
import relativeTime from "./ru/relativeTime";
import layers from "./ru/layers";
import home from "./ru/home";
import admin from "./ru/admin";
import audit from "./ru/audit";
import widgets from "./ru/widgets";
import gallery from "./ru/gallery";
import designSystem from "./ru/designSystem";
import projectDetail from "./ru/projectDetail";
import functionalMap from "./ru/functionalMap";
import architecturePage from "./ru/architecturePage";
import planPage from "./ru/planPage";
import automations from "./ru/automations";
import rss from "./ru/rss";
import editor from "./ru/editor";
import aiHub from "./ru/aiHub";
import bottomBar from "./ru/bottomBar";
import comms from "./ru/comms";
import email from "./ru/email";
import pwa from "./ru/pwa";
import entities from "./ru/entities";
import wiki from "./ru/wiki";
import toolkit from "./ru/toolkit";
import iconPicker from "./ru/iconPicker";
import grid from "./ru/grid";
import slides from "./ru/slides";
import matching from "./ru/matching";
import contractor from "./ru/contractor";
import importEngine from "./ru/importEngine";
import gmail from "./ru/gmail";
import googleCalendar from "./ru/googleCalendar";
import courses from "./ru/courses";
import workspaceSwitcher from "./ru/workspaceSwitcher";
import knowledge from "./ru/knowledge";

export const ru = { tabs, pages, appLauncher, apps, auditLog, roadmapPage, ceoQueue, common, speedDial, smartBar, auth, settings, sidebar, tray, shellPrefs, userMenu, downloads, brand, contextMenu, elementLabels, elementDescriptions, guide, folders, fieldLibrary, canvas, storyMap, health, dashboardHome, hub, boardroom, documentsPage, export: exportNs, docControl, docTemplates, docFields, fieldConfig, emailTemplates, emailDesigner, relativeTime, layers, home, admin, audit, widgets, gallery, designSystem, projectDetail, functionalMap, architecturePage, planPage, automations, rss, editor, aiHub, bottomBar, comms, email, pwa, entities, wiki, toolkit, iconPicker, grid, slides, matching, contractor, importEngine, gmail, googleCalendar, courses, workspaceSwitcher, knowledge } as const;
